import keys from 'lodash/keys';
import pick from 'lodash/pick';

import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { postRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';

import { put, takeEvery, call } from 'redux-saga/effects';

export function* listener(serviceType, action) {
  try {
    const model = {
      trfId: null,
      qrfId: null,
      PDCA: null,
      failureDesc: null,
      rootCause: null,
      comment: null,
      correctiveAction: null,
      dateOfCompletion: null,
      attachment: null,
      RSLNo: null,
      proposedCorrectiveAction: null
    };
    const path = {
      history: null
    };
    const result = pick(action.data, keys(model));
    const routes = pick(action.data, keys(path));
    const data = { ...result };
    const infoPopDuration = 1000;
    yield call(displayMessage, 'info', 'Submitting your data..', infoPopDuration);
    yield put(createServiceAction(serviceType, 'loading')());
    const res = yield call(postRequest, apiConfig.frfData.endPointUrl, data);
    // Display HTTP status error message
    const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
    if(!statusErrorMessage){  
      const response = yield res.json();
      // Display server error message
      const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
      if (!serverErrorMessage && response.errorCode === 0) {
        yield put(createServiceAction(serviceType, 'success')(response));
        const message = `${response.message}`;
        // Display success message
        yield call(displayMessage, 'success', message, 5000);
        if(action.data.proposedCorrectiveAction === 'Yes'){
          routes.history.push('/trf',{ rslId: result.RSLNo , isRetest: 'Yes',trfId: result.trfId, isPartialEdit: true,preLoadMaterial:true});
        }else{
          routes.history.push(`/download-frf/`, { trfId: result.trfId });
        }
       // routes.history.push(`/download-frf/`, { trfId: result.trfId, qrfId: result.qrfId });
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* frfSagas() {
  const serviceType = 'frfSubmit';

  yield takeEvery(createServiceAction(serviceType, 'submitted').type, listener, serviceType);
}

export default frfSagas;
